<div class="nb-treeview">
  <tree-root #treeModel [nodes]="data" [options]="innerOptions">
    <ng-template #treeNodeTemplate let-node="node" let-index="index">
      <div class="nb-treeview-node-template">
        <div class="nb-treeview-node-label">
          <span *ngIf="nodeTemplate; else plainLabel">
            <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: node, index: index }"></ng-container>
          </span>

          <ng-template #plainLabel>
            <span>{{ node.data[innerOptions.displayField] }}</span>
          </ng-template>
        </div>

        <div class="nb-treeview-node-dropdown-arrow" *ngIf="options.enableNodeDropdown">
          <i class="fas fa-caret-square-down" (click)="openDropdownMenu($event)"></i>
        </div>
      </div>
      <!-- <button (click)="go($event)">Custom Action</button> -->
    </ng-template>
  </tree-root>
</div>
